(function () {

  /* ================= WAIT FOR SLICK ================= */
  function waitForSlick(callback, retries = 30) {
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
      callback(window.jQuery);
    } else if (retries > 0) {
      setTimeout(() => waitForSlick(callback, retries - 1), 100);
    } else {
      console.warn("Slick not loaded");
    }
  }

  /* ================= GLIDE INITIALIZER ================= */
  function initLookbookGlide(scope = document) {
    const glides = scope.querySelectorAll(".lookbook-glide");

    glides.forEach((el) => {
      if (el.classList.contains("glide-initialized")) return;

      const glide = new Glide(el, {
        type: el.dataset.type || "carousel",
        startAt: parseInt(el.dataset.start) || 0,
        perView: parseInt(el.dataset.perview) || 1,
        autoplay: parseInt(el.dataset.autoplay) || false,
        hoverpause: el.dataset.hoverpause === "true",
        animationDuration: parseInt(el.dataset.animation) || 400,
        rewind: el.dataset.rewind === "true",
        gap: parseInt(el.dataset.gap) || 0,
        focusAt: el.dataset.focus || 0,
        breakpoints: {
          1024: { perView: parseInt(el.dataset.tablet) || 1 },
          768: { perView: parseInt(el.dataset.mobile) || 1 },
        },
      });

      glide.mount();
      el.classList.add("glide-initialized");

      /* Hover pin navigation */
      el.querySelectorAll(".marker").forEach((marker) => {
        marker.addEventListener("mouseenter", () => {
          const index = marker.dataset.glideDir?.replace("=", "");
          if (index !== undefined) {
            glide.go("=" + index);
          }
        });
      });
    });
  }

  /* ================= SLICK INITIALIZER ================= */
  function initLookbookSlick(scope = document) {
  waitForSlick(($) => {

    $(scope).find(".lookbook-slider").each(function () {
      const $slider = $(this);

      /* Prevent double init */
      if ($slider.hasClass("slick-initialized")) return;

      /* Prevent crash if only 1 slide */
      if ($slider.children(".lookbook-section").length <= 1) {
        console.warn("⚠️ Not enough slides for Slick");
        return;
      }

      /* ================= READ DATA ATTRIBUTES ================= */
      const autoplay = String($slider.data('autoplay')) === 'true';
      let autoplaySpeed = parseInt($slider.data('autoplay-timeout')) || 3000;
      const loop = String($slider.data('loop')) === 'true';
      const arrows = String($slider.data('nav')) === 'true';
      const dots = String($slider.data('dots')) === 'true';
      const rtl = String($slider.data('rtl')) === 'true';
      const speed = parseInt($slider.data('speed')) || 800;

      /* Disable autoplay in Shopify editor */
      if (window.Shopify && Shopify.designMode) {
        autoplaySpeed = 999999;
      }

      /* ================= EVENTS ================= */
      $slider.off('init afterChange beforeChange');

      $slider.on('init', function (event, slick) {

        const $firstSlide = $(slick.$slides[0]);

        /* Safe optional hooks */
        if (typeof runAnimations === "function") {
          runAnimations($firstSlide);
        }

        if (typeof runImageZoom === "function") {
          runImageZoom($firstSlide, slick);
        }

        /* DOT SVG (only if enabled) */
        if (dots) {
          $slider.find('.slick-dots li').each(function () {
            $(this).html(`
              <button>
                <svg class="progress-ring" width="30" height="30">
                  <circle cx="15" cy="15" r="14"></circle>
                </svg>
              </button>
            `);
          });

          if (typeof startDotProgress === "function") {
            startDotProgress($slider, 0, slick.options.autoplaySpeed);
          }
        }
      });

      $slider.on('afterChange', function (event, slick, currentSlide) {
        const $currentSlide = $(slick.$slides[currentSlide]);

        if (typeof runAnimations === "function") {
          runAnimations($currentSlide);
        }

        if (typeof runImageZoom === "function") {
          runImageZoom($currentSlide, slick);
        }
      });

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (typeof startDotProgress === "function") {
          startDotProgress($slider, nextSlide, slick.options.autoplaySpeed);
        }
      });

      /* ================= INIT ================= */
      setTimeout(() => {
        $slider.slick({
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          infinite: loop,
          speed: speed,
          rtl: rtl,
          lazyLoad: 'progressive',
          arrows: arrows,
          dots: dots,

          /* 🔥 LOOKBOOK SAFE SETTINGS */
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,

          prevArrow: `
            <button class="slick-nav prev-arrow scroll-btn scroll-btn--left shadow-sm glass-effect" aria-label="Previous">
              <svg class="icon icon-caret w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"></path>
              </svg>
            </button>
          `,
          nextArrow: `
            <button class="slick-nav next-arrow scroll-btn scroll-btn--right shadow-sm glass-effect" aria-label="Next">
              <svg class="icon icon-caret w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"></path>
              </svg>
            </button>
          `
        });

        /* Fix layout + Glide */
        setTimeout(() => {
          $slider.slick('setPosition');
          window.dispatchEvent(new Event('resize'));
        }, 200);

      }, 50);

    });

  });
}

  /* ================= INITIALIZE ALL ================= */
  function initLookbook(scope = document) {

    /* 1. Init Glide first */
    initLookbookGlide(scope);

    /* 2. Delay Slick to avoid DOM conflicts */
    setTimeout(() => {
      initLookbookSlick(scope);
    }, 120);
  }

  /* ================= FIRST LOAD ================= */
  document.addEventListener("DOMContentLoaded", () => {
    initLookbook(document);
  });

  /* ================= SHOPIFY SECTION LOAD ================= */
  document.addEventListener("shopify:section:load", (event) => {
    initLookbook(event.target);
  });

  /* ================= OPTIONAL AJAX ================= */
  document.addEventListener("ajaxComplete", () => {
    initLookbook(document);
  });

})();